import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import { secondaryColor } from "../../style/color";

export const ProfileCard = ({
  username,
  phone,
  image,
  dis,
  showMessageButton = true,
  email,
  premium = false,
}) => {
  const handleNoContact = (type) => {
    alert(`No ${type} found`);
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: premium ? "20px" : "1.25rem",
        height: premium ? "auto" : { xl: "12.64rem" },
        minHeight: premium ? 168 : "12.69rem",
        width: "100%",
        border: premium ? "1px solid" : "none",
        borderColor: premium ? alpha("#11409B", 0.1) : "transparent",
        boxShadow: premium
          ? "0 4px 24px rgba(15, 23, 42, 0.06)"
          : "none",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "column",
        transition: premium ? "transform 0.25s, box-shadow 0.25s" : "none",
        "&:hover": premium
          ? {
              transform: "translateY(-3px)",
              boxShadow: "0 12px 32px rgba(17, 64, 155, 0.12)",
            }
          : {},
      }}
    >
      <CardContent className="textArea">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {image ? (
            <Avatar
              sx={{
                width: premium ? 52 : "3.938rem",
                height: premium ? 52 : "3.938rem",
                mt: 2,
                border: premium ? "3px solid #fff" : "none",
                boxShadow: premium
                  ? "0 4px 16px rgba(17, 64, 155, 0.2)"
                  : "none",
                bgcolor: premium ? "#11409B" : undefined,
              }}
              src={image?.pictureUrl}
              alt="image"
            >
              {!image?.pictureUrl &&
                (username?.[0] || phone?.[0] || "?").toUpperCase()}
            </Avatar>
          ) : (
            <Avatar
              sx={{
                width: premium ? 52 : "3.938rem",
                height: premium ? 52 : "3.938rem",
                mt: 2,
                bgcolor: premium ? "#11409B" : undefined,
              }}
            >
              {(username?.[0] || phone?.[0] || "?").toUpperCase()}
            </Avatar>
          )}
        </Box>
        <Stack mt={"0.313rem"}>
          <Typography
            variant="medium"
            component={"h3"}
            mx={"auto"}
            sx={{
              fontSize: { xl: "17.27", md: "17px", xs: "10px", sm: "10px" },
              fontWeight: "bold",
            }}
          >
            {username ? username : phone}
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="small" color={secondaryColor.light} mx={"auto"}>
            {dis}
          </Typography>
        </Stack>

        <Stack
          mt={"0.469rem"}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton
            width="1.25rem"
            height="1.25rem"
            sx={{ marginRight: "0.625rem" }}
            component="a"
            href={email ? `mailto:${email}` : "#"}
            onClick={(e) => {
              if (!email) {
                e.preventDefault();
                handleNoContact("email");
              }
            }}
          >
            <img src="/Email.svg" alt="email" />
          </IconButton>
          <IconButton
            width="1.25rem"
            height="1.25rem"
            component="a"
            href={phone ? `tel:${phone}` : "#"}
            onClick={(e) => {
              if (!phone) {
                e.preventDefault();
                handleNoContact("phone");
              }
            }}
          >
            <img src="/Phone.svg" alt="phone" />
          </IconButton>

          {showMessageButton && (
            <IconButton width="1.25rem" height="1.25rem">
              <img src="/Chat.svg" alt="message" />
            </IconButton>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
